"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debounce = void 0;
const debouncify_1 = require("./debouncify");
function debounce(delayMs) {
    return (target, propertyName, descriptor) => {
        if (descriptor.value) {
            const methodsMap = new WeakMap();
            const originalMethod = descriptor.value;
            descriptor.value = function (...args) {
                if (!methodsMap.has(this)) {
                    methodsMap.set(this, (0, debouncify_1.debouncify)(originalMethod, delayMs).bind(this));
                }
                methodsMap.get(this)(...args);
            };
            return descriptor;
        }
        throw new Error('@debounce is applicable only on a methods.');
    };
}
exports.debounce = debounce;
